import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 40,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
        <g clipPath="url(#clip0_13_2)">
          <path d="M8.74199 32.8456L0.942881 19.337C0.642969 18.8176 0.485077 18.2284 0.485077 17.6286C0.485077 17.0289 0.642969 16.4397 0.942881 15.9202L8.74169 2.4119C9.04157 1.89243 9.47292 1.46107 9.99238 1.16119C10.5118 0.8613 11.1011 0.703455 11.7009 0.703522H27.2991C27.8989 0.703507 28.4881 0.861377 29.0075 1.16126C29.5269 1.46115 29.9582 1.89248 30.258 2.4119L38.0571 15.9205C38.357 16.4399 38.5149 17.0292 38.5149 17.6289C38.5149 18.2287 38.357 18.8179 38.0571 19.3373L30.258 32.8456C29.9582 33.3651 29.5269 33.7964 29.0075 34.0963C28.4881 34.3962 27.8989 34.554 27.2991 34.554H11.7009C11.1011 34.554 10.5119 34.3962 9.99255 34.0963C9.47315 33.7964 9.04184 33.3651 8.74199 32.8456Z" fill="url(#paint0_linear_13_2)"/>
          <path opacity="0.07" d="M24.2974 10.4822L38.5723 24.8169L28.7249 38.2967L14.7023 25.6327L10.8286 18.4409L12.3828 18.6661L10.5876 16.843L15.489 11.028L22.9257 9.68777L24.161 10.9229L24.2974 10.4822Z" fill="black"/>
          <path d="M28.4133 17.6387L24.2974 10.4823L20.1816 17.6387L24.2974 24.7952L28.4133 17.6387Z" fill="#DAE7FC"/>
          <path d="M10.5867 18.2332L14.6877 25.3635H22.9111L18.8101 18.2332H10.5867Z" fill="#B6CFF8"/>
          <path d="M18.7572 17.0445L22.9242 9.91388H14.7005L10.5867 17.0445H18.7572Z" fill="white"/>
        </g>
        <defs>
          <linearGradient id="paint0_linear_13_2" x1="19.5" y1="0.703522" x2="19.5" y2="34.5014" gradientUnits="userSpaceOnUse">
            <stop stopColor="#000080"/>
            <stop offset="1" stopColor="#003CA0"/>
          </linearGradient>
          <clipPath id="clip0_13_2">
            <rect width="39" height="39" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
